<template>
    <div>
        <v-card flat>
            <v-card-title>
                <span class="text-h5">Set: {{ reference }} {{ originLabel ? `Origen: ${originLabel}` : ''
                    }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="3" sm="3" md="3" class="pb-0">
                            <v-text-field v-model="reference" label="Codigo-Referencia" outlined class="mb-3"
                                :disabled="isDisabled || reference === ''"></v-text-field>
                        </v-col>
                        <v-col cols="3" sm="3" md="3" class="pb-0">
                            <v-autocomplete v-model="centerCost" :items="itemsCostCenters" label="Centro de Costo"
                                :disabled="isDisabled" outlined auto-select-first></v-autocomplete>
                        </v-col>
                        <v-col cols="4" sm="4" md="4" class="pb-0">
                            <v-autocomplete v-model="position" :items="itemsPositions" label="Posicion / Cargo"
                                auto-select-first outlined ref="cod"></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" md="2" class="pb-0">
                            <v-autocomplete v-model="zone" :items="itemsZones" label="Zona" :disabled="isDisabled"
                                auto-select-first outlined ref="cod"></v-autocomplete>
                        </v-col>


                    </v-row>
                    <v-row>
                        <!-- <v-col cols="3" sm="3" md="3" class="pb-0">
                            <v-autocomplete v-model="sex" :items="itemSex" label="Sexo" auto-select-first outlined
                                ref="cod"></v-autocomplete>
                        </v-col> -->
                        <v-col cols="2" sm="2" md="2" class="pb-0">
                            <v-text-field v-model="renovation" label="Renovacion Meses" outlined class="mb-3"
                                type="number" :disabled="disableRef"></v-text-field>
                        </v-col>

                        <v-col cols="7" sm="7" md="7" class="pb-0">
                            <v-autocomplete v-model="category" :items="itemsCategories" label="Categoria Producto"
                                auto-select-first outlined ref="cod"></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" md="2" class="pb-0">
                            <v-text-field v-model="quantity" label="Cantidad" outlined required
                                type="number"></v-text-field>
                        </v-col>
                        <v-col cols="1" sm="1" md="1">
                            <v-icon color="success" @click="onList" v-text="'mdi-check-outline'"
                                :disabled="!isNewItemOk"></v-icon> -
                            <v-icon v-if="disableRef" color="warning" @click="onEdit"
                                v-text="'mdi-circle-edit-outline'"></v-icon>
                        </v-col>
                    </v-row>
                    <br>
                    <v-data-table :headers="headers" :items="itemsAggregate" class="elevation-1 custom-font">
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-icon small @click="deleteItem(item)">
                                mdi-delete
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancelStock">
                    Cancelar
                </v-btn>
                <v-btn :disabled="!isOk" color="blue darken-1" text @click="saveStock">
                    Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>

</template>
<script>
import { getCostCenters, getPositions, getKitById, getSex, getCategories, getInventoryZonesItems } from '@/dataApi'

export default {
    props: {
        kit: {
            type: Number,
            required: true
        }
    },
    name: 'kits',
    data: () => ({
        selectedRef: null,
        category: null,
        quantity: 0,
        centerCost: null,
        position: null,
        zone: null,
        reference: '',
        itemsProducts: [],
        itemsCategories: [],
        itemsCostCenters: [],
        itemsPositions: [],
        itemSex: [],
        itemsAggregate: [],
        itemsZones: [],
        renovation: 0,
        sex: null,
        disableRef: false,
        originLabel: null,
        headers: [
            { text: 'Sexo', value: 'sex' },
            { text: 'Posicion', value: 'position' },
            { text: 'Categoria Producto', value: 'category' },
            { text: 'Cantidad', value: 'quantity' },
            { text: 'Renovacion', value: 'renovation' },
            { text: "Acciones", value: "actions", sortable: false },
        ],

    }),

    methods: {
        async createdValuesItems() {

            this.itemSex = getSex();
            //this.itemsProducts = await getProductsItems();
            this.itemsCategories = await getCategories();
            this.itemsCostCenters = await getCostCenters(true);
            //this.itemsPositions = await getPositions();
            this.itemsZones = await getInventoryZonesItems();

            if (this.kit > 0) {
                const kit = await getKitById(this.kit);

                this.reference = kit.ref;
                this.centerCost = kit.costCenter;
                this.position = kit.items[0].position;
                this.sex = kit.items[0].sex;
                this.renovation = kit.items[0].durationMonths;
                this.zone = kit.zoneId;
                const itemsView = kit.items.map(item => {
                    return {
                        categoryId: item.category.id,
                        quantity: item.quantity,
                        position: item.position,
                        sex: item.sex,
                        renovation: item.durationMonths,
                        category: item.category.name
                    }
                })
                this.itemsAggregate = itemsView;
            }
        },

        async onList() {
            const quantity = parseInt(this.quantity)
            const category = this.itemsCategories.find(category => category.value === this.category)
            const exist = this.itemsAggregate.findIndex(item => item.categoryId === this.category && item.position === this.position
                && item.centerCost === this.centerCost)
            if (exist !== -1) {
                this.itemsAggregate[exist].quantity += quantity;
            } else {
                this.itemsAggregate.push({
                    categoryId: this.category,
                    category: category.text,
                    quantity,
                    position: this.position,
                    sex: 'U',
                    renovation: this.renovation,
                    reference: this.reference,
                    centerCost: this.centerCost
                });
            }
            this.category = null;
            this.disableRef = true;
            console.log(this.itemsAggregate)
        },

        deleteItem(item) {
            const index = this.itemsAggregate.findIndex(ele => ele.categoryId === item.categoryId && ele.position === item.position && ele.sex === item.sex)
            console.log(item, index)
            if (index !== -1) {
                this.itemsAggregate.splice(index, 1);
            }
        },

        onEdit() {
            this.disableRef = false;
            this.originLabel = null;
        },

        cancelStock() {
            this.$emit("closeModal", {})
        },

        saveStock() {
            const kits = {
                ref: this.reference,
                costCenter: this.centerCost,
                items: [],
                zoneId: this.zone
            }
            this.itemsAggregate.forEach(item => {
                kits.items.push({
                    sex: item.sex,
                    position: item.position,
                    categoryId: item.categoryId,
                    quantity: item.quantity,
                    durationMonths: parseInt(item.renovation)
                })
            })
            console.log(kits)
            this.$emit("saveStock", kits)

        },
        closeModal() {
            this.getKitView = false;
            this.kitId = null;
            this.keyView++;
        },
        viewRequest(kit) {
            this.kitId = kit.id;
            this.keyView++;
            this.getKitView = true;
        },
    },

    mounted() {
        this.createdValuesItems();
    },

    watch: {
        async centerCost(newVal) {
            this.reference = `${newVal}-${Date.now().toString().slice(-6)}`
            this.itemsPositions = await getPositions(newVal)
        }
    },

    computed: {
        isNewItemOk() {
            return this.category !== null && parseInt(this.quantity) !== 0;
        },
        isOk() {
            return this.itemsAggregate.length > 0 && this.reference != '';
        },
        isDisabled() {
            return this.itemsAggregate.length > 0
        }
    }
}
</script>